import { render, staticRenderFns } from "./HospitalIcon.vue?vue&type=template&id=174791b3&"
import script from "./HospitalIcon.vue?vue&type=script&lang=js&"
export * from "./HospitalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports